import {
    Alert,
    Box,
    Button, CircularProgress,
    Container,
    Divider,
    Grid,
    List, ListItem, ListItemButton, ListItemIcon, ListItemText, Radio,
    Typography
} from "@mui/material";
import React, {MouseEventHandler, useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {useUserDataContext, useUserLoginContext} from "../Contexts/UserContext";
import {useListSubscriptionsQuery} from "../generated/graphql";
import {useBasketContext, useBasketDataContext} from "../Contexts/BasketContext";
import { useSiteDataContext } from "../Contexts/SiteDataContext";

function SelectMembershipPage() {
    const navigate = useNavigate();
    const setUser = useUserLoginContext();
    const user = useUserDataContext();
    const text = useSiteDataContext();
    const pageText = text.pages["selectMembership"];
    //const [selected, setSelected] = useState<string|null>(null);
    const [optionResult] = useListSubscriptionsQuery({variables:{theatre:text.siteData.subdomain,token:(user?.token)??''}});
    const basketData = useBasketDataContext();
    const basket = useBasketContext();
    const changeValue = (option): MouseEventHandler<HTMLDivElement> => (evt) => {
        basket.setSubscription(option);
//        setSelected(id);
    }
    const formatter = Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    function priceAsPounds(price) {
        return formatter.format(price/100);
    }
    useEffect(()=>{
        if(!basketData) return;
        if(!basketData.customer) {
            navigate('/');
        }
    },[basketData]);

    useEffect(()=>{
        if(optionResult && optionResult.data?.subscriptions?.subscriptions?.length ==1) {
            basket.setSubscription(optionResult.data.subscriptions.subscriptions[0]);
            navigate('/payment');
        }
    },[optionResult]);

    console.log('basketData is',basketData);
    return (<Container maxWidth="md">
        <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
                <Typography typography="h1" color="primary">{pageText.title}</Typography>
                <Typography typography="subtitle" color="primary">{pageText.subtitle}</Typography>
                <Divider sx={
                    (theme) => ({
                        paddingTop: theme.spacing(4)
                    })}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                {!!optionResult?.data?.subscriptions?.error &&
                  <Alert severity="error" sx={(theme)=>({borderRadius: 0, marginBottom:theme.spacing(2)})}>{optionResult?.data?.subscriptions?.error}</Alert>
                }                {optionResult.fetching &&
                  <Box sx={{width:'100%',display:'flex',minHeight:'5rem',alignItems:"center",justifyContent:"center"}}><CircularProgress/></Box> }
                {!optionResult.fetching && <List>
                    {optionResult?.data?.subscriptions?.subscriptions?.map((option) => (
                        <ListItem key={option.id}>
                            <ListItemButton
                                selected={basketData?.subscription?.id == option.id}
                                role={undefined} onClick={changeValue(option)} dense>
                                <ListItemIcon>
                                    <Radio
                                        edge="start"
                                        checked={basketData?.subscription?.id == option.id}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{'aria-labelledby': 'label-' + option.id}}
                                    />
                                </ListItemIcon>
                                <ListItemText id={'label-' + option.id} secondary={option.description}>
                                    <Typography gutterBottom={true} typography="h3" color="primary">{option.name+' '+priceAsPounds(option.price)}</Typography>
                                </ListItemText>
                            </ListItemButton>
                        </ListItem>))}
                </List>
                }
                <Button color="secondary" sx={(theme) => ({marginTop: theme.spacing(4), marginBottom: theme.spacing(4)})} fullWidth={true}
                        onClick={() => {
                            navigate('/payment')
                        }} variant="contained" size="large"
                disabled={optionResult?.data?.subscriptions?.error || !basketData?.subscription}>{pageText.continueButton}</Button>
            </Grid>
        </Grid>
    </Container>);
}

export default SelectMembershipPage;